exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".t_alternate.additional-header[data-v-06f7245c] thead th:nth-child(7),.t_alternate.additional-header[data-v-06f7245c] thead th:nth-child(8),.t_alternate.additional-header[data-v-06f7245c] thead th:nth-child(9),.t_alternate.additional-header[data-v-06f7245c] thead th:nth-child(10),.t_alternate.additional-header[data-v-06f7245c] thead th:nth-child(11),.t_alternate.additional-header[data-v-06f7245c] thead th:nth-child(12){background-color:#f0f0f0!important}", ""]);

// exports
